<template>
  <div>
    <b-modal
      id="sign-up-modal"
      title="Sign up"
      centered
    >
      <div class="form-group text-left">
        <label for="username-label">Email address</label>
        <b-form-input
          v-model="email"
          v-b-tooltip.hover
          class="form-control"
          placeholder="Your sky email address"
          :state="emailState"
          title="Press Enter to submit"
          :formatter="format"
          style="margin-bottom: 0;"
          @keyup.enter.native="clickedSubmit()"
        />
        <div
          v-show="!emailState"
          style="font-size: 10pt; color: red; margin-top: 0.5rem; margin-bottom: 1rem; text-align: left;"
        >
          Your email needs to be ending with @sky.uk, @sky.de, @sky.at or @iwedia.com
        </div>
      </div>

      <PasswordRePasswordComponent ref="passwordRePasswordRef" />

      <div
        slot="modal-footer"
        class="w-100"
      >
        <b-btn
          class="footer-button"
          :disabled="!emailState || is_signing_up"
          size="xl"
          variant="success"
          enabled="!showLoading"
          @click="clickedSubmit()"
        >
          <i
            v-show="is_signing_up"
            class="fa fa-spinner fa-spin"
          /> Sign Up
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal'
import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

import utils from '../../utils.js'

import PasswordRePasswordComponent from './PasswordRePasswordComponent.vue'

import USER_API from '../../api/user'

import { EVENT_SIGN_UP_EMAIL } from '../../constants.js'

export default {

	components: {
		PasswordRePasswordComponent
	},
	props: {
		initialEmail: {
			type: String,
			required: true
		}
	},

	data () {
		return {
			email: '',
			is_signing_up: false
		}
	},

	computed: {
		emailState () {
			return utils.validateEmail(this.email)
		}
	},

	// We watch the props being changed and update the email accordingly
	watch: {
	  	initialEmail: {
	    	handler: function (initialEmail) {
	      		this.email = this.initialEmail
	    	},
	    	immediate: true
		}
	},

	methods: {
		format: function (value, event) {
			return value.toLowerCase()
		},

		clickedSubmit: function () {
			console.debug('Sign UP this.email : ' + this.email)
			console.debug('this.password : ' + this.$refs.passwordRePasswordRef.password)

			if (!this.is_signing_up) {
				console.debug('clickedSendPassword 2')

				this.$refs.passwordRePasswordRef.resetShowErrors()

				// Invalid Email
				if (!utils.validateEmail(this.email)) {
					print("Email isn't valid")
				}
				// Password match
				else if (this.$refs.passwordRePasswordRef.validate()) {
					console.debug('clickedSendPassword All Good')

					var reference = this

					this.is_signing_up = true

					const params = {
						email: this.email,
						password: this.$refs.passwordRePasswordRef.getPassword()
					}

					USER_API.sign_up(params,
						(user_sub) => {
							reference.is_signing_up = false
							reference.$emit(EVENT_SIGN_UP_EMAIL, reference.email, user_sub, reference.$refs.passwordRePasswordRef.password)

							reference.$root.$emit('bv::hide::modal', 'sign-up-modal')
	                        reference.$root.$emit('bv::show::modal', 'sign-up-confirm-code-modal')
						},
						e => {
							console.debug(e)

							reference.is_signing_up = false

							if (e.hasOwnProperty('response')) {
								const response = e['response']

								if (response.hasOwnProperty('data')) {
									const data = response['data']

									if (data.hasOwnProperty('error')) {
										const error = data['error']
										utils.makeToast(reference.$bvToast, 'Error', 'danger', error)

										return
									}
								}
							}
							utils.makeToast(reference.$bvToast, 'Error', 'danger', "You couldn't be registered. Please try again or contact your line manager")
						}
					)
            	}
			} else {
				console.debug('clickedSendPassword already loading')
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
h1
	color: green

#forgot-password-input-container
	text-align: left
</style>
